/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const CREATEEXPERIENCE= createAsyncThunk(
  "createExperience/createExperience",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createExperienceSlice = createSlice({
  name: "createExperienceSlice",
  initialState: {
    createExperience: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateExperience: (state) => {
        state.createExperience.loading = false
        state.createExperience.error = false
        state.createExperience.data = []
        state.createExperience.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEEXPERIENCE.fulfilled, (state, action) => {
      state.createExperience = {
        ...state.createExperience,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEEXPERIENCE.pending, (state, action) => {
      state.createExperience = {
        ...state.createExperience,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEEXPERIENCE.rejected, (state, action) => {
      state.createExperience = {
        ...state.createExperience,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createExperienceAction = {
    CREATEEXPERIENCE,
};

export { createExperienceAction };
export default createExperienceSlice.reducer;
export const {setInitialStateOfcreateExperience} = createExperienceSlice.actions